import ProductListingPanel from './productListingPanel.container';

export default ProductListingPanel;